import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-468e3933"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")

import { ref, reactive, onBeforeMount, onMounted } from 'vue'
    import { ElMessage, ElMessageBox } from 'element-plus'
    import Api from '@/http/modules/index'
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const {
        // 员工变更日志_查询
        'POST/users/modify/record/all/query':recordAllApi,
         // 获取所有团队
        'GET/organizations': organizationsApi,
        // 用户下拉列表
        'GET/users/list': usersListApi,
    } = Api
    const pageInfo=reactive({
        page:1,
        size:30,
        total:0
    })
    const tableHeight= window.innerHeight-200
    const queryInfo=ref<any>({})
    const orgLists=ref<any>([])
    const userLists=ref<any>([])
    const userOptionLists=ref<any>([])
    const tableLoading=ref(false)
    const optionloading=ref(false)
    const modifyLogs=ref([])
    const getModifyLog=(isReset:boolean=false)=>{
        if(isReset){
            pageInfo.page=1
            queryInfo.value={}
        }
        let {page,size}=pageInfo
        let params={
            ...queryInfo.value,
            page,size
        }
        tableLoading.value=true
        recordAllApi(params).then((res:any)=>{
            modifyLogs.value=res.data
            pageInfo.total=res.rowCount
        }).finally(()=>{
            tableLoading.value=false
        })
    }
    const remoteMethod=(query:any)=>{
        if (query) {
            optionloading.value = true
            setTimeout(() => {
                optionloading.value = false
                let resultArr:any=[]
                resultArr = userLists.value.filter((item:any) => {
                    return item.realName.includes(query)||item.username.toLowerCase().includes(query.toLowerCase())
                })
                userOptionLists.value=resultArr.slice(0,20)
            }, 200)
        } else {
            userOptionLists.value = []
        }
    }
    onMounted(()=>{
        organizationsApi().then((res:any)=>{
            orgLists.value=res
        })
        usersListApi().then((res:any)=>{
            userLists.value=res
        })
        getModifyLog()
    })
  
return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_form, {
        inline: "",
        model: queryInfo.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "操作详情" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: queryInfo.value.operationDetail,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryInfo.value.operationDetail) = $event)),
                clearable: "",
                class: "form-input",
                maxlength: "200",
                placeholder: "请输入操作详情"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "所属团队:" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: "",
                modelValue: queryInfo.value.orgIdList,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryInfo.value.orgIdList) = $event)),
                clearable: "",
                multiple: "",
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                placeholder: "请您选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orgLists.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      value: item.id,
                      label: item.name
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "所属员工:" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                loading: optionloading.value,
                filterable: "",
                modelValue: queryInfo.value.userIdList,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryInfo.value.userIdList) = $event)),
                remote: "",
                "remote-method": remoteMethod,
                "reserve-keyword": "",
                clearable: "",
                multiple: "",
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                placeholder: "请您选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userOptionLists.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.userId,
                      value: item.userId,
                      label: `${item.realName} (${item.username })`
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["loading", "modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (getModifyLog()))
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (getModifyLog(true)))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createVNode(_component_el_divider),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: modifyLogs.value,
      "max-height": tableHeight+'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "操作人",
          prop: "operatorName",
          "show-overflow-tooltip": "",
          width: "200"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作时间",
          prop: "operationTime",
          "show-overflow-tooltip": "",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作类型",
          prop: "type",
          "show-overflow-tooltip": "",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          label: "所属团队",
          prop: "orgName",
          "show-overflow-tooltip": "",
          width: "200"
        }),
        _createVNode(_component_el_table_column, {
          label: "所属员工",
          prop: "userName",
          "show-overflow-tooltip": "",
          width: "200"
        }),
        _createVNode(_component_el_table_column, {
          label: "所属模块",
          prop: "modularName",
          "show-overflow-tooltip": "",
          width: "200"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作详情",
          prop: "operationDetail",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, tableLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(pageInfo).total,
      "page-size": _unref(pageInfo).size,
      currentPage: _unref(pageInfo).page,
      "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_unref(pageInfo).page) = $event)),
      class: "mb-5 mt-5",
      "page-sizes": [30, 60, 90, 120],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _cache[6] || (_cache[6] = ()=>getModifyLog()),
      onSizeChange: _cache[7] || (_cache[7] = ()=>getModifyLog())
    }, null, 8, ["total", "page-size", "currentPage"])
  ]))
}
}

})